import { apiSlice } from "../api/apiSlice";

export const quizMarkAPI = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getQuizMarks: builder.query({
      query: () => "/quizMark",
    }),
    getQuizMarkOfStudent: builder.query({
      query: ({ video_id, student_id }) =>
        `/QuizMark?video_id=${video_id}&student_id=${student_id}`,
      providesTags: ["quizMarkOfStudent"],
    }),

    addQuizMark: builder.mutation({
      query: (data) => ({
        url: "/quizMark",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["quizMarkOfStudent"],

      async onQueryStarted(data, { queryFulfilled, dispatch }) {
        try {
          const addResult = await queryFulfilled;
          dispatch(
            apiSlice.util.updateQueryData(
              "getQuizMarks",
              undefined,
              (draft) => {
                draft.push(addResult.data);
              }
            )
          );
        } catch (error) {
          console.error("Something Went Wrong!");
          console.error(error);
        }
      },
    }),
  }),
});

export const {
  useGetQuizMarksQuery,
  useGetQuizMarkOfStudentQuery,
  useAddQuizMarkMutation,
} = quizMarkAPI;
